// NGRX
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { QueryResultsModel } from '../../_base/crud';
import { ApplicationQrveyState } from '../_reducers/application-qrvey.reducers';
import { ApplicationQrvey } from '../_models/application-qrvey.model';

export const selectApplicationQrveyState =
  createFeatureSelector<ApplicationQrveyState>('applicationQrvey');

export const selectApplicationQrveyById = (applicationQrveyId: number) =>
  createSelector(
    selectApplicationQrveyState,
    (applicationQrveyState) => applicationQrveyState.entities[applicationQrveyId],
  );

export const selectApplicationQrveyPageLoading = createSelector(
  selectApplicationQrveyState,
  (applicationQrveyState) => {
    return applicationQrveyState.listLoading;
  },
);

export const selectApplicationQrveyActionLoading = createSelector(
  selectApplicationQrveyState,
  (applicationQrveyState) => applicationQrveyState.actionsloading,
);

export const selectLastCreatedApplicationQrveyId = createSelector(
  selectApplicationQrveyState,
  (applicationQrveyState) => applicationQrveyState.lastCreatedApplicationQrveyId,
);

export const selectApplicationQrveyPageLastQuery = createSelector(
  selectApplicationQrveyState,
  (applicationQrveyState) => applicationQrveyState.lastQuery,
);
export const selectApplicationQrveyError = createSelector(
  selectApplicationQrveyState,
  (applicationQrveyState) => applicationQrveyState.error,
);
export const selectApplicationQrveyLatestSuccessfullAction = createSelector(
  selectApplicationQrveyState,
  (applicationQrveyState) => applicationQrveyState.latestSuccessfullAction,
);
export const selectApplicationQrveyInStore = createSelector(
  selectApplicationQrveyState,
  (applicationQrveyState) => {
    const items = (applicationQrveyState.ids as number[])
      .map((id) => applicationQrveyState.entities[id])
      .filter((item): item is ApplicationQrvey => item !== undefined);
    return new QueryResultsModel(items, applicationQrveyState.totalCount);
  },
);

export const selectApplicationQrveyShowInitWaitingMessage = createSelector(
  selectApplicationQrveyState,
  (applicationQrveyState) => applicationQrveyState.showInitWaitingMessage,
);

export const selectHasApplicationQrveyInStore = createSelector(
  selectApplicationQrveyState,
  (queryResult) => {
    if (!queryResult.totalCount) {
      return false;
    }

    return true;
  },
);
